import Head from 'next/head';
import Colors from '@/components/Colors';

const Page: React.FC = () => {
  return (
    <>
      <Head>
        <title>Farben</title>
      </Head>
      <Colors />
    </>
  );
};

export default Page;
